import React from 'react'
import PropTypes from 'prop-types'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'

function PartnerVisit({ data }) {
  const {
    partnerLogo: { altText, image }
  } = data

  return (
    <section className="partners">
      <div className="container__inner">
        <div className="partners__content-box">
          <p className="partners__text general-text">Thanks for coming from our partner at</p>
          <div className="partners__img-box partners__img-box--card">
            <GatsbyImage image={getImage(image.image)} alt={altText} />
          </div>
        </div>
      </div>
    </section>
  )
}

PartnerVisit.propTypes = {
  data: PropTypes.object.isRequired
}

export default PartnerVisit
